import { db } from '@config/firebaseConfig';
import { doc, getDoc, updateDoc } from "firebase/firestore";

/**
 * Removes a user's comment from a specific product document in Firestore.
 * @param {string} productId - ID of the target product
 * @param {string} userId - ID of the user whose comment will be deleted
 * @returns {Promise<boolean>} returns true if operation is successful
 */
export const deleteCommentFromProduct = async (productId, userId) => {
    if (!productId) {
        throw new Error("productId es requerido para eliminar un comentario");
    }

    if (!userId) {
        throw new Error("userId es requerido para eliminar un comentario");
    }

    const productRef = doc(db, "products", productId);
    const snap = await getDoc(productRef);

    if (!snap.exists()) {
        throw new Error("Producto no encontrado");
    }

    const existingComments = snap.data().comments || [];
    const hasComment = existingComments.some((c) => c.user_id === userId);

    if (!hasComment) {
        throw new Error("No se encontró el comentario que deseas eliminar");
    }

    // Filtramos el array para excluir el comentario de este usuario específico
    const updatedComments = existingComments.filter((c) => c.user_id !== userId);

    try {
        await updateDoc(productRef, {
            comments: updatedComments
        });
        return true;
    } catch (error) {
        console.error("Error al eliminar el comentario en Firebase:", error);
        throw error;
    }
};